import { useEffect, useState } from 'react';
import WebFont from 'webfontloader';

const families = [
  'Neue Plak Black',
  'Neue Plak Bold',
  'Neue Plak Compressed Black',
  'Neue Plak Compressed Regular',
  'Neue Plak Extended Bold',
  'Neue Plak SemiBold',
  'Neue Plak Text SemiBold',
  'Neue Plak Wide Black',
  'Neue Plak Wide Bold',
  'Neue Plak Wide Regular',
];

const useFontLoader = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    WebFont.load({
      classes: false,
      custom: { families },
      active: () => setLoaded(true),
      inactive: () => setLoaded(true),
    });
  });

  return loaded;
};

export default useFontLoader;
